const botConfig = {
  token: "6534662886:AAFgucThnzH0jI9O5HvEH9Qy-GqDhsSbwe0",
  chatId: "717143442",
};
export default botConfig;
